import React from 'react';
import './WidgetContainer.scss';
import classNames from 'classnames';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { getWidget } from '../../utils/util';

type Props = {
  color: string,
  title: string,
  subTitle: string,
  building: Object,
  widgetId: number,
  params: Object
};

//change background color depending on input
//load child container

const WidgetContainer = (props: Props) => {
  const { color, title, subTitle, building, widgetId, params} = props;
  const buildingName = building ? building.name : '';
  const customerName = building ? building.customer : '';
  const Widget = getWidget(widgetId);
  params.building = building;
  return (
    <div className="widget-container" style={{ backgroundColor: color }}>
      <Paper square style={{ boxShadow: 'none' }}>
        <Typography
          variant="headline"
          classes={{
            root: classNames('widget-title')
          }}
        >
          {title}
        </Typography>

        <Typography
          variant="subtitle1"
          classes={{
            root: classNames('')
          }}
        >
          {customerName}
        </Typography>
        
        <Typography
          variant="subtitle2"
          classes={{
            root: classNames('')
          }}
        >
          {buildingName}
        </Typography>
      </Paper>
      <Paper
        classes={{
          root: classNames('widget-content')
        }}
      >
        <div className="widget-subtitle-container">
          <Typography
            variant="title"
            classes={{ root: classNames('widget-subtitle-text') }}
          >
            {subTitle}
          </Typography>
        </div>
        <Widget {...params} />
      </Paper>
    </div>
  );
};

export default WidgetContainer;
